import PropTypes from 'prop-types';
import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Immutable from 'immutable';
import _ from 'underscore';
import BookingActionCreator from 'action_creators/booking';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import FormController from 'lib/form/controller';
import Landing from 'views/anyguide_bookings/review/landing';
import Message from 'views/anyguide_bookings/review/message';
import Confirmation from 'views/anyguide_bookings/review/confirmation';
import ModalActionCreator from 'action_creators/modal';
import GlobalError from 'views/plugins/global_error';

var ReviewMixin = {
  mixins: [PureRenderMixin, FormController, StoreInterestMixin],

  propTypes: {
    booking_id: PropTypes.number.isRequired,
    guests: PropTypes.number.isRequired,
    tour_name: PropTypes.string.isRequired,
    guest_firstname: PropTypes.string.isRequired,
  },

  getInitialState: function () {
    return {
      step: 'landing',
      errors: Immutable.Map({}),
      fields: Immutable.Map({ reason: null }),
      rejecting: false,
      rejectingCompleted: false,
      rejectingError: null,
      rejectingFailed: false,
    };
  },

  getStoreInterests: function () {
    return {
      rejecting: 'booking.rejecting',
      rejectingCompleted: 'booking.rejectingCompleted',
      rejectingError: 'booking.rejectingError',
      rejectingFailed: 'booking.rejectingFailed',
    };
  },

  componentDidUpdate: function (prevProps, prevState) {
    if (
      this.state.rejectingCompleted === true &&
      prevState.rejectingCompleted === false
    ) {
      this.setState({ step: 'confirmation' });
    }

    if (this.state.rejectingFailed !== prevState.rejectingFailed) {
      ModalActionCreator.show({
        content: this._errorComponent(),
        className: 'small GlobalError-Modal-Plugin modal',
        settings: { closable: false },
        showButton: false,
        showIcon: false,
      });
    }
  },

  formSubmitted: function (params) {
    BookingActionCreator.decline({
      id: this.props.booking_id,
      reason: this.state.fields.get('reason'),
    });
  },

  validationConstraints: function () {
    return {};
  },

  _errorComponent: function () {
    return (
      <GlobalError
        defaultErrorMessage="Something went wrong when trying to reject your booking"
        secondaryMessage="Please contact us at support@anyroad.com."
        showButton={false}
      />
    );
  },

  _landingProps: function () {
    var _this = this;

    return _.extend({}, this.props, {
      theme: this.props.theme,
      handleDeclineClicked: function (e) {
        e.preventDefault();
        _this.setState({ step: 'message' });
      },
    });
  },

  _messageProps: function () {
    var _this = this,
      reasonProps;

    reasonProps = _.extend(this._formProps('reason'), {
      placeholder: 'Add a message',
      onChange: this.onChange,
    });

    return {
      theme: this.props.theme,
      guest_firstname: this.props.guest_firstname,
      rejecting: this.state.rejecting,
      rejectingCompleted: this.state.rejectingCompleted,
      rejectingError: this.state.rejectingError,
      reasonProps: reasonProps,
      onSubmit: this.onSubmit,
      handleCancelClicked: function (e) {
        e.preventDefault();
        _this.setState({ step: 'landing' });
      },
    };
  },

  _renderStep: function () {
    return {
      landing: <Landing {...this._landingProps()} />,
      message: <Message {...this._messageProps()} />,
      confirmation: <Confirmation theme={this.props.theme} />,
    };
  },
};

export default ReviewMixin;
